import React, { useRef, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { useHasPermission } from "../../../../hooks/useHasPermission";

export default function CommentSection({
    comments = [],
    onSend,
    loading = false,
    currentUser = null,
    ticket = null,
}) {
    const isOwnTicket =
        Number(ticket?.createdByUserId) === Number(currentUser?.id);
    //console.log('my ticket=======', isOwnTicket, currentUser?.id, ticket?.createdBy);
    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [isInternal, setIsInternal] = useState(false);
    const fileInputRef = useRef(null);

    const canView = useHasPermission("Support-view");
    const canManage = useHasPermission("Support-manage");
    const currentRole = localStorage.getItem("role");
    const isSuperAdmin =
        currentRole === "SUPER_ADMIN" ||
        currentUser?.role === "SUPER_ADMIN" ||
        ["superadmin-hrms@moptra.com", "superadmin@moptra.com"].includes(
            currentUser?.email
        );

    const formatDate = (date) => {
        if (!date) return "-";
        return new Date(date).toLocaleString("en-GB");
    };

    /* ================= FILTER COMMENTS ================= */
    /* ================= FILTER COMMENTS ================= */
    const filteredComments = useMemo(() => {
        return comments.filter((c) => {
            // Super admin sab dekh sakta hai
            if (isSuperAdmin) return true;
            // Internal comments
            if (c?.isInternal) {
                // Ticket creator ko hide karo
                if (
                    Number(ticket?.createdByUserId) === Number(currentUser?.id)
                ) {
                    return false;
                }
                // Sirf HR permission wale dekh sakte hain
                if (!(canView || canManage)) {
                    return false;
                }
            }

            return true;
        });
    }, [
        comments,
        canView,
        canManage,
        isSuperAdmin,
        currentUser,
        ticket,
    ]);
    // console.log({
    //     canView,
    //     canManage,
    //     currentRole,
    //     currentUser,
    // });

    /* ================= SEND ================= */
    const handleSend = () => {
        if (!message.trim()) return;

        const payload = {
            comment: message,
            isInternal,
            file: selectedFile,
        };

        onSend(payload);

        setMessage("");
        setSelectedFile(null);
        setIsInternal(false);
    };

    return (
        <>
            {filteredComments.length === 0 ? (
                <p className="server-error-msg text-center">-- No comments yet --</p>
            ) : (
                filteredComments.map((msg) => (
                    <div key={msg.id} className="message-wrapper incoming">
                        <div className="user-icon blue-icon">
                            {msg?.commentedByName?.charAt(0)}
                        </div>

                        <div className="message-content">
                            <span className="user-meta">
                                <strong>{msg?.commentedByName}</strong> •{" "}
                                {formatDate(msg?.commentedAt)}
                            </span>

                            <div className="bubble"
                                style={{
                                    background: msg?.isInternal ? "#fff3cd" : "",
                                    border: msg?.isInternal ? "1px solid #ffeeba" : "",
                                }}
                            >
                                {msg?.comment}

                                {msg?.isInternal && (
                                    <div
                                        style={{
                                            fontSize: "11px",
                                            marginTop: "4px",
                                            color: "#856404",
                                        }}
                                    >
                                        Internal Note
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))
            )}

            {/* REPLY SECTION */}
            <div className="reply-section">
                {selectedFile && (
                    <div className="file-preview-tag">
                        {selectedFile.name}
                        <button
                            type="button"
                            className="ms-2 btn-close"
                            style={{ fontSize: "10px" }}
                            onClick={() => setSelectedFile(null)}
                        ></button>
                    </div>
                )}

                <textarea
                    className="conversation-text"
                    placeholder="Type your message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                />
                {(isSuperAdmin || ((canView || canManage) && !isOwnTicket)) && (
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <input
                            type="checkbox"
                            id="internalComment"
                            checked={isInternal}
                            onChange={(e) => setIsInternal(e.target.checked)}
                        />
                        <label htmlFor="internalComment" className="mb-0">
                            Internal Comment (Only visible to authorized users)
                        </label>
                    </div>
                )}

                <div className="reply-actions">
                    <input
                        type="file"
                        ref={fileInputRef}
                        hidden
                        onChange={(e) => setSelectedFile(e.target.files[0])}
                    />

                    <button
                        type="button"
                        className="send-btn primary-btn"
                        onClick={handleSend}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Add Comment"}
                    </button>
                </div>
            </div>
        </>
    );
}

CommentSection.propTypes = {
    comments: PropTypes.array,
    onSend: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    currentUser: PropTypes.object,
};